var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgF6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 162,
    viewBox: "0 0 183 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    width: 168,
    height: 154,
    rx: 16,
    fill: "#C83333",
    stroke: "#C83333",
    strokeWidth: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 174,
    height: 156,
    rx: 19,
    fill: "white",
    stroke: "#C83333",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.194 67.2131C119.588 54.4564 107.953 44.8333 94 44.8333C82.9217 44.8333 73.3192 50.915 68.5083 59.7964C56.9892 61.0017 48 70.4394 48 81.9167C48 94.2098 58.2925 104.167 71 104.167H120.833C131.413 104.167 140 95.86 140 85.625C140 75.835 132.123 67.8992 122.194 67.2131ZM94 96.75L74.8333 78.2083H86.3333V63.375H101.667V78.2083H113.167L94 96.75Z",
    fill: "#14A06F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.78a249bacb0d8c03b3ec1af49f794cd9.svg";
export { ForwardRef as ReactComponent };